(function () {
    'use strict';

    angular
        .module('app.campaignActivity')
        .controller('campaignActivityAddNoteCtrl', ['$rootScope', '$scope', '$modal', '$modalInstance', 'campaignActivityService',
            function ($rootScope, $scope, $modal, $modalInstance, campaignActivityService) {
                $scope.closeModalAddNote = function (result) {
                    $modalInstance.close(result);
                }

                $scope.addNote = function () {
                    if ($scope.noteContent == null || $scope.noteContent == ''){
                        $rootScope.handleRequestError({message: 'Please input content.'}, $scope);
                        return;
                    }

                    var params = {
                        campaign_influencer_id: $scope.campaign_influencer_id,
                        subject: $scope.subject,
                        content: $scope.noteContent
                    };

                    campaignActivityService.addNote(params)
                        .then(function (response) {
                            $scope.closeModalAddNote(response.data);
                        }, function (errResponse) {
                            $rootScope.handleRequestError(errResponse, $scope);
                        });
                }
            }
        ]);
})();
